import React from "react";
import PropTypes from "prop-types";

export function Wrapper(props) {
  return <div className={props.className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * className for wrapper
   */
  className: PropTypes.string,
  /**
   * child coomponents
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

Wrapper.defaultProps = {
  className: "",
};
